import { push } from "connected-react-router";
import CryptoJS from "crypto-js";
import { createBrowserHistory } from "history";
import { globals } from "../../globals";
const history = createBrowserHistory();
// ------------------------------------
// Constants
// ------------------------------------
export const USER_LOGIN_START = "USER_LOGIN_START";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOG_OUT = "USER_LOG_OUT";
export const USER_LOG_OUT_START = "USER_LOG_OUT_START";
export const LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";
export const USER_LOG_OUT_FAILURE = "USER_LOG_OUT_FAILURE";
export const DELETE_RECORDS_LOCKS_SUCCESS = "DELETE_RECORDS_LOCKS_SUCCESS";
export const DELETE_RECORDS_LOCKS_START = "DELETE_RECORDS_LOCKS_START";
export const DELETE_RECORDS_LOCKS_FAILURE = "DELETE_RECORDS_LOCKS_FAILURE";
export const USER_FORGOT_START = "USER_FORGOT_START";
export const USER_FORGOT_SUCCESS = "USER_FORGOT_SUCCESS";
export const USER_FORGOT_FAIL = "USER_FORGOT_FAIL";
export const USER_CODEVALIDATE_START = "USER_CODEVALIDATE_START";
export const USER_CODEVALIDATE_SUCCESS = "USER_CODEVALIDATE_SUCCESS";
export const USER_CODEVALIDATE_FAIL = "USER_CODEVALIDATE_FAIL";
export const USER_PWORDREGEN_START = "USER_PWORDREGEN_START";
export const USER_PWORDREGEN_SUCCESS = "USER_PWORDREGEN_SUCCESS";
export const USER_PWORDREGEN_FAIL = "USER_PWORDREGEN_FAIL";

const headers = {
  "Content-Type": "application/x-www-form-urlencoded",
};

export function getUserFromCookie() {
	const options = {
		method: "GET",
		credentials: "include",
		mode: "cors",
		headers
	};

	// Call API method to get userInfo for a user that has logged in via some other means.
	// This call relies on myAuthCookie.
  const url = `${globals.apiUrl}/user/currentuser`;
	return fetch(url, options)
		.then((response) => {
			if (response.status === 200) {
				return response.json();
			}
		})
		.then((json) => {
			if (json) {
				return json;
			}
		})
		.catch((err) => {
			console.log(err);
		});
}

export function silentcookieLogin() {

	console.log('auth.cookieLogin() called');

  return (dispatch) => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    dispatch({ type: USER_LOGIN_START });
    const options = {
      method: "GET",
      credentials: "include",
      mode: "cors",
      headers
    };
		// Call API method to get userInfo for a user that has logged in via some other means.
		// This call relies on myAuthCookie.
    const url = `${globals.apiUrl}/user/currentuser`;
    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_LOGIN_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_LOGIN_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(json),
            "myAuthCookie"
          );
          localStorage.setItem("authData", encryptedData);          
					sessionStorage.setItem("verifiedUser", json.Username);
          //setTimeout(() => logOut(), 259200000); // log out in 72 hours

          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: { json },
          }); 

          return json;
        }

      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_LOGIN_FAIL });
      });
  };
}

export function cookieLogin() {

	console.log('auth.cookieLogin() was called');

  return (dispatch) => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    dispatch({ type: USER_LOGIN_START });
    const options = {
      method: "GET",
      credentials: "include",
      mode: "cors",
      headers
    };
		// Call API method to get userInfo for a user that has logged in via some other means.
		// This call relies on myAuthCookie.
    return fetch(`${globals.apiUrl}/user/currentuser`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_LOGIN_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_LOGIN_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(json),
            "myAuthCookie"
          );
					sessionStorage.setItem("verifiedUser", json.Username);
          localStorage.setItem("authData", encryptedData);
          setTimeout(() => logOut(), 259200000); // log out in 72 hours

          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: { json },
          });

          dispatch(push("/"));

					console.log('auth.cookieLogin() returning');

          return json;
        }

      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_LOGIN_FAIL });
      });
  };

}

export function logIn(username, password, rememberMe) {

	console.log("auth.logIn() was called")

  const user = encodeURIComponent(username);
  const pass = encodeURIComponent(password);
  return (dispatch) => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    dispatch({ type: USER_LOGIN_START });
    const options = {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers,
      body: `UserName=${user}&Password=${pass}`,
    };
    fetch(`${globals.apiUrl}/auth/login`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_LOGIN_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_LOGIN_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: { json },
          });
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(json),
            "myAuthCookie"
          );
					sessionStorage.setItem("verifiedUser", json.Username);
          localStorage.setItem("authData", encryptedData);
          setTimeout(() => logOut(), 259200000); // log out in 72 hours
          if (rememberMe) {
            var credentials = {
              userName: user,
              userPassword: pass,
            };
            const logData = CryptoJS.AES.encrypt(
              JSON.stringify(credentials),
              "myAuthCookie"
            );
            localStorage.setItem("logData", logData);
          }

          // dispatch(push("/"));         
					console.log('auth.logIn() returning');
				}

      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_LOGIN_FAIL });
      });
  };
}


export function logInTk(ax, yd, vc) {

	console.log("auth.logInTk() was called")

  const p1 = encodeURIComponent(ax);
  const p2 = encodeURIComponent(yd);
  const p3 = encodeURIComponent(vc);

  return (dispatch) => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    dispatch({ type: USER_LOGIN_START });
    const options = {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers,
      body: `ax=${p1}&yd=${p2}&vc=${p3}`,
    };
    fetch(`${globals.apiUrl}/auth/loginTk`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_LOGIN_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_LOGIN_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: { json },
          });
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(json),
            "myAuthCookie"
          );
					sessionStorage.setItem("verifiedUser", json.Username);
          localStorage.setItem("authData", encryptedData);
          setTimeout(() => logOut(), 259200000); // log out in 72 hours
          if (rememberMe) {
            // var credentials = {
            //   userName: user,
            //   userPassword: pass,
            // };
            // const logData = CryptoJS.AES.encrypt(
            //   JSON.stringify(credentials),
            //   "myAuthCookie"
            // );
            // localStorage.setItem("logData", logData);
          }

          dispatch(push("/ssignon"));    
					console.log('auth.logInTk() returning');
				}

      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_LOGIN_FAIL });
      });
  };
}

export function logOut() {
  return (dispatch) => {
    dispatch({ type: USER_LOG_OUT_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

		sessionStorage.removeItem("verifiedUser");

    fetch(`${globals.apiUrl}/auth/logout`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        }
      })
      .then((text) => {
        dispatch({ type: USER_LOG_OUT, text });
        history.push("/login");
        setTimeout(localStorage.removeItem("authData"), 500);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_LOG_OUT_FAILURE });
      });
  };
}

export function forgotPw(emailaddr, modeType) {
	console.log("auth.forgotPw() was called")
  const email = encodeURIComponent(emailaddr);
  const mode = encodeURIComponent(modeType);

  return (dispatch) => {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    dispatch({ type: USER_LOGIN_START });
    const options = {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers,
      body: `Email=${email}&Mode=${mode}`,
    };
    fetch(`${globals.apiUrl}/auth/forgot`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_FORGOT_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_FORGOT_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: USER_FORGOT_SUCCESS,
            payload: { json },
            previousMode: modeType
          });
          // dispatch(push("/"));         
					console.log('auth.forgotPw() returning');
				}
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_FORGOT_FAIL });
      });
  };
}

export function validateCode(emailaddr, modeType, codeValue, tokenValue) {
	console.log("auth.validateCode() was called")
  const email = encodeURIComponent(emailaddr);
  const mode = encodeURIComponent(modeType);
  const code = encodeURIComponent(codeValue);
  const ctoken1 = encodeURIComponent(tokenValue);

  return (dispatch) => {
    dispatch({ type: USER_CODEVALIDATE_START });
    const options = {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers,
      body: `Email=${email}&Mode=${mode}&Code=${code}&CToken1=${ctoken1}`,
    };
    fetch(`${globals.apiUrl}/auth/validate`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_CODEVALIDATE_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_CODEVALIDATE_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: USER_CODEVALIDATE_SUCCESS,
            payload: { json },
          });
          // dispatch(push("/"));         
					console.log('auth.validateCode() returning');
				}
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_CODEVALIDATE_FAIL });
      });
  };
}
// email, displayMode, cToken1, cToken2, pword
export function updateStrongPw(emailaddr, modeType, tokenValue, tokenValue2, newPw) {
	console.log("auth.updateStrongPw() was called");
  const email = encodeURIComponent(emailaddr);
  const mode = encodeURIComponent(modeType);
  const ctoken1 = encodeURIComponent(tokenValue);
  const ctoken2 = encodeURIComponent(tokenValue2);
  const newpword = encodeURIComponent(newPw);

  return (dispatch) => {
    dispatch({ type: USER_PWORDREGEN_START });
    const options = {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers,
      body: `Email=${email}&Mode=${mode}&CToken1=${ctoken1}&CToken2=${ctoken2}&Pw=${newpword}`,
    };
    fetch(`${globals.apiUrl}/auth/updatepw`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch({ type: USER_PWORDREGEN_FAIL });
        } else if (response.status === 400) {
          dispatch({ type: USER_PWORDREGEN_FAIL });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: USER_PWORDREGEN_SUCCESS,
            payload: { json },
          });
          // dispatch(push("/"));         
					console.log('auth.updateStrongPw() returning');
				}
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: USER_PWORDREGEN_FAIL });
      });
  };
}

export const actions = {
  logIn,
  logOut,
  decryptAuthData,
  forgotPw, 
  validateCode,
  updateStrongPw,
};

export function decryptAuthData() {
  const authData = localStorage.getItem("authData");
  try {
    if (authData) {
      const decrypted = CryptoJS.AES.decrypt(
        authData.toString(),
        "myAuthCookie"
      );
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    } else {
      localStorage.removeItem("authData");
      return {};
    }
  } catch (err) {
    localStorage.removeItem("authData");
    console.log(err);
    dispatch({ type: USER_LOG_OUT_FAILURE });
  };
}

export function deleteRecordsLocks() {
  return (dispatch) => {
    dispatch({ type: DELETE_RECORDS_LOCKS_START });
    const options = {
      method: "DELETE",
      credentials: "include",
    };
    fetch(`${globals.apiUrl}/auth/deleterecordlocks`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        }
      })
      .then((text) => {
        dispatch({ type: DELETE_RECORDS_LOCKS_SUCCESS, text });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_RECORDS_LOCKS_FAILURE });
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [USER_LOGIN_START]: (state) => {
    return {
      ...state,
      isLoggingIn: true,
      successLogin: false,
    };
  },
  [USER_LOG_OUT]: (state) => {
    return {
      ...state,
      isLoggingIn: false,
      successLogin: false,
    };
  },
  [USER_LOGIN_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLoggingIn: false,
      successLogin: true,
      authData: json,
    };
  },
  [USER_LOGIN_FAIL]: (state) => {
    return {
      ...state,
      isLoggingIn: false,
      successLogin: false,
    };
  },
  [USER_LOG_OUT_FAILURE]: (state) => {
    return {
      ...state,
      isLoggingIn: false,
      successLogin: false,
    };
  },
  [USER_FORGOT_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const nextDisplayMode = action.previousMode == 'username' ? 'usernamesent' : 'entercode'
    return {
      ...state,      
      isInvalidCode: false, 
      reasonMessage: "",
      displayMode: nextDisplayMode,
      otuData: json,
    };
  },
  [USER_FORGOT_FAIL]: (state) => {
    return {
      ...state,
      otuData: {}
    };
  },
  [USER_CODEVALIDATE_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    // only replace otuData if IsValid. 
    if(json.IsValid){
      return {
        ...state,
        displayMode: json && json.IsValid ? 'enterpass' : 'entercode',
        reasonMessage: json.Reason,
        isInvalidCode: !json.IsValid,
        otuData: json,
      };
    }else{
      return {
        ...state,
        displayMode: json && json.IsValid ? 'enterpass' : 'entercode',
        reasonMessage: json.Reason,
        isInvalidCode: !json.IsValid,
      };
    }
    // return {
    //   ...state,
    //   displayMode: json && json.IsValid ? 'enterpass' : 'entercode',
    //   reasonMessage: json.Reason,
    //   isInvalidCode: !json.IsValid,
    //   otuData: json,
    // };
  },
  [USER_CODEVALIDATE_FAIL]: (state) => {
    return {
      ...state,
      displayMode: 'entercode',
      isInvalidCode: true,
      reasonMessage: "Code mismatch. ", 
    };
  },
  [USER_PWORDREGEN_SUCCESS]: (state, action) => {
    const { json } = action.payload;
      return {
        ...state,      
        displayMode: json && json.IsSuccess ? 'gologon' : 'enterpass',
        isInvalidPassword: !json.IsSucces,
        reasonMessage: json.Reason,
      };
  },
  [USER_PWORDREGEN_FAIL]: (state) => {
    return {
      ...state,
      displayMode: 'enterpass',
      isInvalidPassword: true,
      reasonMessage: "Password update failed. Please contact Statescape support. "
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isLoggingIn: false,
  successLogin: !!localStorage.getItem("authData"),
  authData: localStorage.getItem("authData") ? decryptAuthData() : {},
  otuData: null, 
  displayMode: '',
  isInvalidCode: false,
  isInvalidPassword: false,
};

export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js